import { render, staticRenderFns } from "./TempletDoubleStyle.vue?vue&type=template&id=1d57a53f&scoped=true&"
import script from "./TempletDoubleStyle.vue?vue&type=script&lang=js&"
export * from "./TempletDoubleStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d57a53f",
  null
  
)

export default component.exports